import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M7.75 4C8.16421 4 8.5 4.33579 8.5 4.75C8.5 5.16421 8.16421 5.5 7.75 5.5H6V19H7.75C8.16421 19 8.5 19.3358 8.5 19.75C8.5 20.1642 8.16421 20.5 7.75 20.5H2.75C2.33579 20.5 2 20.1642 2 19.75C2 19.3358 2.33579 19 2.75 19H4.5V5.5H2.75C2.33579 5.5 2 5.16421 2 4.75C2 4.33579 2.33579 4 2.75 4H7.75ZM16.25 5C17.6997 5 18.875 6.17525 18.875 7.625V11.7197H20.25C21.2164 11.7197 21.9999 12.5034 22 13.4697V20.5H10.5V13.4697C10.5001 12.5034 11.2836 11.7197 12.25 11.7197H13.625V7.625C13.625 6.17525 14.8003 5 16.25 5ZM12 19H13.4502V17.8502H14.9502V19H17.4502V17.8502H18.9502V19H20.5V16.0498H12V19ZM16.25 6.5C15.6287 6.5 15.125 7.00368 15.125 7.625V13.2197H12.25C12.112 13.2197 12.0001 13.3318 12 13.4697V14.5498H20.5V13.4697C20.4999 13.3318 20.388 13.2197 20.25 13.2197H17.375V7.625C17.375 7.00368 16.8713 6.5 16.25 6.5Z';

const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const FormatPainterCursorIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'formatPainterCursor')) as IconWithRender;

FormatPainterCursorIcon.displayName = 'FormatPainterCursorIcon';
FormatPainterCursorIcon.renderIcon = (props) => (
  <FormatPainterCursorIcon {...props} />
);
export default FormatPainterCursorIcon;
